import {
  APIBase,
  Exceptions,
  Meta,
  Request,
  responseFactory,
} from '@weblite-wapps/protocol'
import { sendResponseToWapp } from '$logic/wapp-communication/wapp-communication.publish'

type Handler<A extends APIBase> = (
  payload: A['reqPayload'],
  meta: Meta,
) => Promise<A['resPayload']> | A['resPayload']

interface Subscriber<A extends APIBase> {
  [type: string]: Handler<A>[]
}

export default class WappSubscription {
  subscribers: Subscriber<APIBase> = {}

  subscribe<A extends APIBase>(actionType: string, handler: Handler<A>) {
    if (this.subscribers[actionType]) this.subscribers[actionType].push(handler)
    else this.subscribers[actionType] = [handler]
  }

  publish<T extends APIBase>(action: Request<T['reqPayload']>) {
    const { type, payload, meta } = action

    if (!this.subscribers[type])
      sendResponseToWapp(
        responseFactory()({ errorCode: Exceptions.API_NOT_FOUND }, meta),
      )

    this.subscribers[type]?.forEach(async (handler: Handler<T>) => {
      const response = await handler(payload, meta)
      sendResponseToWapp(responseFactory()(response, meta))
    })
  }
}

export const wappSubscription = new WappSubscription()
